import Vue from 'vue';
import Vuex from 'vuex';

import rootState from './state';
import rootMutations from './mutations';
import rootActions from './actions';
import * as rootGetters from './getters';
import ReportingStore from '@/modules/reporting/store';
import DynamicInboundCallsStore from '@/modules/dynamicInboundCalls/store';
import ApiTokenStore from '@/modules/apiTokens/store';
import ExportFilesStore from '@/modules/exportFiles/store';
import BlockedNumbersStore from '@/modules/blockedNumbers/store';
import TargetStore from '@/modules/targets/store';
import AssetStore from '@/modules/viewAssets/store';
import UserGroupStore from '@/modules/userGroups/store';
import UsersStore from '@/modules/users/store';
import InvitesStore from '@/modules/invites/store';
import TcpaShieldStore from '@/modules/tcpaShield/store';
import AuthStore from '@/modules/auth/store';
import VuexReset from '@ianwalter/vuex-reset';
import LoginSecurityStore from '@/modules/loginSecurity/store';
import TwoFactorAuthStore from '@/modules/twoFactorAuth/store';
import OpenRegistrationStore from '@/modules/openRegistration/store';
import NumberStore from '@/modules/number/store';
import UrlParametersStore from '@/modules/urlParameters/store';
import ChangeLogStore from '@/core/components/ChangeLog/store';
import BillingSettingsStore from '@/modules/billingSettings/store';
import CallFlowStore from '@/modules/ivrs/store';
import UiStore from '../modules/ui';
import Webhooks from '@/modules/webhooks/store';
import RtbStats from '@/modules/rtbStats/store';
import RtbLogs from '@/modules/rtbLogs/store';
import RingTreeTargets from '@/modules/ringTreeTargets/store';
import RingTrees from '@/modules/ringTree/store';
import CampaignsStore from '@/modules/campaigns/store';
import InfoStore from '@/modules/info/store';
import AuthConnections from '@/modules/authConnections/store';
import Buyers from '@/modules/buyers/store';
import PredictiveRouting from '@/modules/predictiveRouting/store';
import Publisher from '@/modules/publisher/store';
import BulkTags from '@/modules/bulkTags/store';
import RateLimitStore from '@/modules/rateLimits/store';
import Platforms from '@/modules/platforms/store';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [VuexReset()],
  state: rootState,
  mutations: rootMutations,
  actions: rootActions,
  getters: rootGetters,
  modules: {
    reporting: ReportingStore,
    apiTokens: ApiTokenStore,
    exportFiles: ExportFilesStore,
    twoFactorAuth: TwoFactorAuthStore,
    openRegistrationStore: OpenRegistrationStore,
    blockedNumbers: BlockedNumbersStore,
    dynamicInboundCalls: DynamicInboundCallsStore,
    target: TargetStore,
    assets: AssetStore,
    tcpaShield: TcpaShieldStore,
    userGroups: UserGroupStore,
    users: UsersStore,
    invites: InvitesStore,
    auth: AuthStore,
    loginSecurity: LoginSecurityStore,
    number: NumberStore,
    urlParameters: UrlParametersStore,
    changeLogs: ChangeLogStore,
    billingSettingsStore: BillingSettingsStore,
    callFlows: CallFlowStore,
    rtbStats: RtbStats,
    rtbLogs: RtbLogs,
    ringTreeTargets: RingTreeTargets,
    ui: UiStore,
    webHooks: Webhooks,
    campaigns: CampaignsStore,
    info: InfoStore,
    authConnections: AuthConnections,
    predictiveRouting: PredictiveRouting,
    ringTrees: RingTrees,
    buyersV2: Buyers,
    publisher: Publisher,
    bulkTags: BulkTags,
    rateLimits: RateLimitStore,
    platforms: Platforms
  },
  // eslint-disable-next-line no-undef -- webpack's `mode` inlines process.env.NODE_ENV
  strict: process.env.NODE_ENV !== 'production',
});
